import React, { memo, useEffect, useState } from 'react'
import clsx from 'clsx'
import { IconX } from '@tabler/icons'
import styled from '@emotion/styled'
import { CloseIcon } from '@ow/icons'
import { dayjsInit } from '@ow/utils'
import { useTbViewStore } from '@vt/hooks'
import { convertTime } from '../utils'
import Avatar from '../avatar'

const formatter = (date) => dayjsInit(date).format('YYYY-MM-DD HH:mm')

export const Container = styled.div`
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.1),
    0 8px 10px 1px rgba(0, 0, 0, 0.06), 0 3px 14px 2px rgba(0, 0, 0, 0.05);
`

const Board = ({ label, value }) => {
  if (value === undefined || value === null) return null

  return (
    <div className="w-1/2">
      <p className="text-sm text-gray-300">{label}</p>
      <p className="text-lg mt-1 font-semibold">{value}</p>
    </div>
  )
}

const Header = ({ onClose }) => {
  return (
    <div className="flex items-center justify-between px-5 pt-4">
      <h3 className="text-base font-semibold">检查员轨迹</h3>
      <div className="cursor-pointer" onClick={onClose}>
        <IconX />
      </div>
    </div>
  )
}

const DetailModal = ({ user, isMobile, onClose }) => {
  const [statistics, setStatistics] = useState({})
  const ditto = useTbViewStore((state) => state.ditto)
  useEffect(() => {
    if (!user) return
    const loadDetail = async () => {
      const res = await ditto.fetchInspectStatistics(user.id)

      if (res) {
        setStatistics(res)
      }
    }

    loadDetail()
  }, [user])
  if (!user) return null
  return (
    <Container
      className={clsx(
        'absolute bg-white',
        isMobile
          ? 'w-full left-0 -bottom-4 rounded-2xl z-[90] pb-12'
          : 'w-80 top-8 left-8 rounded-lg'
      )}
    >
      {isMobile && <Header onClose={onClose} />}
      <div>
        <div className="flex items-center gap-3 pt-6 pb-4 px-5 border-b">
          <Avatar user={user} size="l" />
          <div>
            <h3 className="text-sm">{user.name}</h3>
            <p className="text-xs text-gray-300">{user.mobile}</p>
          </div>
        </div>
        <div className="pt-4 pb-6 px-5">
          <div className="flex flex-wrap gap-y-4">
            <Board label="上报案件总数" value={statistics.all} />
            <Board label="当月上报案件数" value={statistics.month} />
            <Board label="当天上报案件数" value={statistics.day} />
            <Board
              label="当天在线时长"
              value={convertTime(user.totalOnlineTime)}
            />
          </div>
          {user.lastInspectTime && (
            <p className="text-gray-300 text-sm mt-2">
              最后上报时间：
              {formatter(user.lastInspectTime)}
            </p>
          )}
          {user.latestLoginTime && (
            <p className="text-gray-300 text-sm mt-2">
              最后定位时间：
              {formatter(user.latestLoginTime)}
            </p>
          )}
        </div>
      </div>
      <div
        className={clsx(
          'cursor-pointer z-10 absolute right-4 top-4',
          isMobile && 'hidden'
        )}
        onClick={onClose}
      >
        <CloseIcon
          width={18}
          height={18}
          fill="rgb(var(--ow-color-gray-300))"
        />
      </div>
    </Container>
  )
}

export default memo(DetailModal)
